export type ListSort = {
  fieldPath: string;
  direction: 'asc' | 'desc';
};

export type ListParams = {
  limit?: number;
  offset?: number;
  filters?: ListFilter[];
  sort?: ListSort;
};

export type ListFilterValue = string | number | boolean | Date;

export type ListFilter = {
  fieldPath: string;
  operator: ListFilterOperator;
  values: ListFilterValue[];
};

export type ListConfig = {
  filters: ListFilterConfig[];
  sorts: ListSortConfig[];
};

export type ListFilterConfig = {
  title: string;
  type: 'string' | 'number' | 'date' | 'enum' | 'boolean';
  fieldPath: string;
  operators: ListFilterOperator[];
  predefinedValues?: ListFilterValue[];
};

export type ListSortConfig = {
  fieldPath: string;
};

export enum ListFilterOperator {
  EQUALS = 'eq',
  NOT_EQUALS = 'neq',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'ncontains',
  GREATER_THAN = 'gt',
  LESS_THAN = 'lt',
  GREATER_THAN_OR_EQUAL = 'gte',
  LESS_THAN_OR_EQUAL = 'lte',
}

export type ListResponse<T> = {
  items: T[];
  total: number;
};
